import { Resource, FieldFactory } from '@/classes';
import { Brand, brandPayloadSchema } from '@/types';

export default function brands() {
  return new Resource<Brand>('Brands')
    .withSchema(brandPayloadSchema)
    .setUseDrawer()
    .withFieldsAndColumns([FieldFactory.text('name')]);
}
